import _asyncToGenerator from "@babel/runtime-corejs3/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Formik } from "formik";
import Spinner from "@xo-union/tk-component-spinner";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { validationSchema } from "./validationSchema.js";
import { utcDateToString } from "./helpers/utcDateToString.js";
import { DateForm } from "./dateForm.js";
import { DatePrefPillGroup } from "./pillGroup.js";
import styles from "./styles.css";
import { DatePreference } from "./types.js";
import { updateDatePrefMutation, weddingDatePreferenceQuery } from "./graphql.js";
import { defaultFormat } from "./helpers/dateTimeFormatted.js";
var defaultConfigs = {
  allowFormat: true,
  showTBA: true,
  defaultView: DatePreference.None
};
var sanitizeArgs = function sanitizeArgs(args) {
  var _context;
  return _reduceInstanceProperty(_context = _Object$keys(args)).call(_context, function (obj, key) {
    var argValue = args[key];
    // set empty strings to null
    if (argValue === '') return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, null));
    // need to convert
    if (key === 'season') argValue = argValue;
    if (key === 'year') argValue = Number(argValue);
    // reverse value from UI
    if (key === 'hideCountdown') argValue = !argValue;
    // force hideDate to be false as long as preference is not TBA
    if (key === 'hideDate' && args.preference !== DatePreference.Tba) argValue = false;
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, argValue));
  }, {
    preference: args.preference
  });
};
var DateDisplay = /*#__PURE__*/React.forwardRef(function (_ref, formikRef) {
  var _ref$config = _ref.config,
    clientConfig = _ref$config === void 0 ? {} : _ref$config,
    onSubmit = _ref.onSubmit,
    onError = _ref.onError;
  var config = useMemo(function () {
    return _objectSpread(_objectSpread({}, defaultConfigs), clientConfig);
  }, [clientConfig]);
  var _useQuery = useQuery(weddingDatePreferenceQuery),
    prefs = _useQuery.data,
    loading = _useQuery.loading;
  var _useMutation = useMutation(updateDatePrefMutation),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    updateDatePreference = _useMutation2[0];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    datePreference = _useState2[0],
    setDatePreference = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    initialValues = _useState4[0],
    setInitialValues = _useState4[1];
  var preference = useMemo(function () {
    var _prefs$weddingDatePre;
    return prefs === null || prefs === void 0 || (_prefs$weddingDatePre = prefs.weddingDatePreferences) === null || _prefs$weddingDatePre === void 0 ? void 0 : _prefs$weddingDatePre.datePreference;
  }, [prefs]);
  var setupInitialView = useCallback(function () {
    var pref = preference;

    // For None view, return defaultView which defaults to None
    if (!pref || pref === DatePreference.None) return config.defaultView;

    // For TBA Returns defaultView if showTBA is false
    if (!(config !== null && config !== void 0 && config.showTBA) && pref === DatePreference.Tba) return config.defaultView;
    return pref || config.defaultView;
  }, [config, preference]);
  useEffect(function () {
    if (!loading && prefs !== null && prefs !== void 0 && prefs.weddingDatePreferences) {
      setInitialValues(prefs.weddingDatePreferences);
    }
  }, [prefs, loading]);
  useEffect(function () {
    if (!loading && preference && datePreference === null) {
      setDatePreference(setupInitialView());
    }
  }, [loading, datePreference, preference, setupInitialView]);
  var valuesToInitialFormikValues = useMemo(function () {
    var res = initialValues;
    var weddingDate = (res === null || res === void 0 ? void 0 : res.weddingDate) || '';
    // Need to format date from DB to union date picker desired format
    var start = res !== null && res !== void 0 && res.weddingDateRangeStart ? utcDateToString(res === null || res === void 0 ? void 0 : res.weddingDateRangeStart) : weddingDate;
    var end = res !== null && res !== void 0 && res.weddingDateRangeEnd ? utcDateToString(res === null || res === void 0 ? void 0 : res.weddingDateRangeEnd) : '';
    return {
      preference: datePreference || config.defaultView,
      date: weddingDate,
      format: (res === null || res === void 0 ? void 0 : res.weddingDateFormat) || defaultFormat,
      rangeStart: start,
      rangeEnd: end,
      season: (res === null || res === void 0 ? void 0 : res.season) || '',
      year: res !== null && res !== void 0 && res.year ? String(res === null || res === void 0 ? void 0 : res.year) : '',
      hideDate: (res === null || res === void 0 ? void 0 : res.hideDate) || false,
      // reverse value for UI
      hideCountdown: !(res !== null && res !== void 0 && res.hideCountdown)
    };
  }, [initialValues, datePreference, config.defaultView]);
  var onSubmitForm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var dateAttrs, _yield$updateDatePref, errors, updateData;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            dateAttrs = sanitizeArgs(values);
            _context2.next = 4;
            return updateDatePreference({
              variables: {
                weddingDatePrefAttrs: dateAttrs
              }
            });
          case 4:
            _yield$updateDatePref = _context2.sent;
            errors = _yield$updateDatePref.errors;
            updateData = _yield$updateDatePref.data.updateWeddingDatePreferences;
            if (!(errors !== null && errors !== void 0 && errors.length)) {
              _context2.next = 9;
              break;
            }
            throw errors;
          case 9:
            onSubmit(updateData);
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            onError(_context2.t0);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return function onSubmitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  if (loading || !prefs || datePreference === null) return /*#__PURE__*/React.createElement(Spinner, {
    "data-testid": "form-spinner"
  });
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: valuesToInitialFormikValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    innerRef: formikRef,
    onSubmit: onSubmitForm
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.group
  }, /*#__PURE__*/React.createElement(DatePrefPillGroup, {
    currentView: datePreference,
    config: config,
    onClick: setDatePreference
  }), /*#__PURE__*/React.createElement(DateForm, {
    currentView: datePreference,
    config: config
  })));
});
export default DateDisplay;